import React, { useState, useEffect } from 'react'

import { Button } from 'Components/shared/Button'
import Input from 'Components/shared/Input'
import { toastWithErrorMessage } from 'Helpers/toast'

import { Flex } from 'lese'

import { useInput, runOnEnter } from 'Helpers'
import CommentService from 'Services/comment'

export default ({ selectedEncounter, updateComments }) => {
  const [encounter, setEncounter] = useState()
  const commentHook = useInput('')

  useEffect(async () => {
    if (!selectedEncounter) return // TODO: Handle error
    setEncounter(selectedEncounter)
  })

  const createComment = async () => {
    const comment = await CommentService.create({
      text: commentHook.value,
      encounterId: encounter.id
    }).catch(err => toastWithErrorMessage(err))

    if (!comment) return

    commentHook.reset()
    updateComments()
  }

  return (
    <Flex row separation="24px" yAlign="center">
      <Input
        placeholder="Comment"
        {...commentHook.bind}
        onKeyDown={runOnEnter(createComment)}
        tabIndex={0}
        fullWidth
      />
      <Button onClick={createComment}>Submit</Button>
    </Flex>
  )
}
